export function needsManageConfig() {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 100,
    menuAlign: "center",
    card: true,
    refreshBtn:false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    column: [{
      label: '搜索查询',
      searchPlaceholder: "客户名称/需求编号",
      placeholder: "客户需求/需求编号",
      prop: "search",
      hide: true,
      display: false,
      search: true,
      hideshow: true,
    },{
      label: '需求状态',
      hideshow: true,
      display: false,
      search: true,
      hide: true,
      type: 'select',
      prop: 'demandStatus',
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=demand_status",
      props: {
        label: "dictValue",
        value: "dictKey",
      }
    },{
      label: '需求类型',
      hide: true,
      search: true,
      prop: 'demandType',
      type: 'select',
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=demand_type",
      props: {
        label: "dictValue",
        value: "dictKey",
      }
    },{
      label: '需求来源',
      hide: true,
      search: true,
      prop: 'demandSource',
      type: 'select',
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=demand_source",
      props: {
        label: "dictValue",
        value: "dictKey",
      }
    },{
      label: '需求编号',
      width: '150',
      prop: 'number'
    },{
      label: '需求客户',
      prop: 'custName'
    },{
      label: '需求类型',
      width: '150',
      prop: 'demandTypeStr'
    },{
      label: '需求状态',
      width: '150',
      slot: true,
      prop: 'status'
    },{
      label: '客户经理',
      width: '150',
      prop: 'managerUserName'
    },{
      label: '需求来源',
      prop: 'demandSourceStr'
    },{
      label: '企业对接人',
      prop: 'companyUser'
    },{
      label: '提交时间',
      prop: 'createTime'
    }]
  }
}

export function visitDetailConfig() {
  return {
    column: [
      {
        label: "拜访名称",
        prop: "demandName",
        url:`/zd/customer/detail/`,
        urlId:'custId'            
      },
      {
        label: "客户名称",
        prop: "demandTypeStr",
      },
      {
        label: "拜访原因",
        prop: "visitPeopleNames",
      },
      {
        label: "拜访人员",
        prop: "companyUser",
      },
      {
        label: "拜访部门",
        prop: "companyPosition",
      },
      {
        label: "拜访时间",
        prop: "companyMobile",
      },
      {
        label: "拜访方式",
        prop: "demandDescribe",
      },
      {
        label: "业务类型",
        prop: "demandDescribe",
      },
      {
        label: "摆放附件",
        prop: "demandDescribe",
      },
      {
        label: "企业对接人",
        prop: "demandDescribe",
      },
      {
        label: "对接人职务",
        prop: "demandDescribe",
      },
      {
        label: "对接人手机号",
        prop: "demandDescribe",
      }
    ],
    showcolumn: [],
    firstsblock: {
      formatter: () => {
        return 24;
      },
    },
    sentersblock: {
      formatter: () => {
        return 0;
      },
    },

    firstrow: {
      formatter: () => {
        return {
          width: "45%",
        };
      },
    },
    secondrow: {
      formatter: () => {
        return {
          width: "25%",
        };
      },
    },
    thirdrow: {
      formatter: () => {
        return {
          width: "30%",
        };
      },
    }
  }
}

export function basicInfoConfig() {
  return {
    basicInfoConfig: {
      column: [{
        label: "项目名称",
        prop: "projectName"
      },{
        label: "项目类型",
        prop: "projectTypeTran"      
      },{
        label: "基金名称",
        prop: "fundName",
        url: ''
      },{
        label: "基金管理人",
        prop: "managerName"
      },{
        label: "基金投资金额",
        prop: "fundAmountTran"
      },{
        label: "带动社会投资额",
        prop: "societyAmountTran"
      },{
        label: "政府产业基金投资额",
        prop: "govIndustryAmountTran"
      },{
        label: "投后报告周期",
        prop: "manageCycleTran",
      },{
        label: "收益情况",
        prop: "income"
      },{
        label: "项目投资日期",
        prop: "projectInvestTime"
      },{
        label: "退出金额",
        prop: "quitAmount"
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },

      firstrow: {
        formatter: () => {
          return {
            width: "35%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "30%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "35%",
          };
        },
      }
    },
    projectInfoConfig: {
      column: [{
        label: "客户名称",
        prop: "custName",
        url: ''
      },{
        label: "纳税识别号",
        prop: "creditCode"
      },{
        label: "所在地",
        prop: "address"
      },{
        label: "设立时间",
        prop: "startDate"
      }],
      firstsblock: {
        formatter: () => {
          return 24;
        },
      },
      sentersblock: {
        formatter: () => {
          return 0;
        },
      },
      firstrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      secondrow: {
        formatter: () => {
          return {
            width: "50%",
          };
        },
      },
      thirdrow: {
        formatter: () => {
          return {
            width: "100%",
          };
        },
      }      
    }
  }
}

export function topInfoConfig() {
  return {
    column: [{
      label: "客户名称",
      prop: "custNames",
      url:`/zd/customer/detail/`,
      urlId:'custId',
      hasId: true
    },{
      label: "需求来源",
      prop: "demandSourceStr"
    },{
      label: "客户经理",
      prop: "managerUserName"
    },{
      label: "企业对接人",
      prop: "companyUser"
    },{
      label: "对接人职务",
      prop: "companyPosition"
    },{
      label: "对接人手机号",
      prop: "companyMobile"
    },{
      label: "需求描述",
      prop: "demandDescribe",
      style: 'width: 100%'
    }],
    firstsblock: {
      formatter: () => {
        return 24;
      },
    },
    sentersblock: {
      formatter: () => {
        return 0;
      },
    },

    firstrow: {
      formatter: () => {
        return {
          width: "33%",
        };
      },
    },
    secondrow: {
      formatter: () => {
        return {
          width: "33%",
        };
      },
    },
    thirdrow: {
      formatter: () => {
        return {
          width: "34%",
        };
      },
    }
  }
}

export function detaillistDemand() {
  return {
    column: [{
      label: "拜访名称",
      prop: "visitName",
      url:`/zd/visit/detail/`,
      urlId:'id'      
    },{
      label: "客户名称",
      prop: "custName"
    },{
      label: "拜访原因",
      prop: "visitReasonStr"
    },{
      label: "拜访人员",
      prop: "companyUser"
    },{
      label: "拜访部门",
      prop: "visitDeptStr"
    },{
      label: "拜访时间",
      prop: "visitTime"
    },{
      label: "拜访方式",
      prop: "visitTypeStr"
    },{
      label: "业务类型",
      prop: "visitBusinessTypeStr"
    },{
      label: "企业对接人",
      prop: "companyUser"
    },{
      label: "对接人职务",
      prop: "companyJob"
    },{
      label: "对接人手机号",
      prop: "companyMobile"
    }],
    firstsblock: {
      formatter: () => {
        return 24;
      },
    },
    sentersblock: {
      formatter: () => {
        return 0;
      },
    },

    firstrow: {
      formatter: () => {
        return {
          width: "33%",
        };
      },
    },
    secondrow: {
      formatter: () => {
        return {
          width: "33%",
        };
      },
    },
    thirdrow: {
      formatter: () => {
        return {
          width: "34%",
        };
      },
    }
  }
}